import SchoolInformationStandAlone from './SchoolInformationStandAlone.page';

export default SchoolInformationStandAlone;